export default "__VITE_ASSET__CaM3czmF__"